module.exports = __webpack_public_path__ + "img/head_hu_aktiv2.72e3506e.png";